import { render, staticRenderFns } from "./features2.component.vue?vue&type=template&id=d79b11ae"
import script from "./features2.component.vue?vue&type=script&lang=js"
export * from "./features2.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports